import React from 'react';
import { NavLink } from 'react-router-dom';
import { featureRoutes } from '../../features/routes';

const Sidebar: React.FC = () => {
  const navigationItems = featureRoutes.filter(route => route.showInNav);

  return (
    <aside className="w-64 bg-white shadow-sm border-r border-gray-200" role="complementary">
      <nav className="p-4 space-y-2" role="navigation" aria-label="Main navigation">
        {navigationItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.navPath || item.path}
            className={({ isActive }) =>
              `flex items-center space-x-3 px-4 py-2 rounded-lg text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 ${
                isActive
                  ? 'bg-blue-50 text-blue-700'
                  : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              }`
            }
            aria-label={item.label}
          >
            {item.icon && <item.icon className="h-5 w-5" aria-hidden="true" />}
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
